import { useDeviceClass } from '../../../shared/hooks/useDeviceClass';
import { AlertsDesktopView } from '../views/AlertsDesktopView';
import { AlertsMobileView } from '../views/AlertsMobileView';
import { AlertsTabletView } from '../views/AlertsTabletView';

export function AlertsPage() {
  const device = useDeviceClass();
  if (device === 'mobile') return <AlertsMobileView />;
  if (device === 'tablet') return <AlertsTabletView />;
  return <AlertsDesktopView />;
}
